module.exports = __webpack_public_path__ + "static/Juho_Kyrola-ea45dd735a042015e6c996a23322510e.jpg";